<script setup lang="ts">
import { ref } from 'vue';
import { ChevronDown } from '@xpos/icons-svg';

const $props = defineProps<{
  modelValue?: string;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);
const currentColor = ref($props.modelValue || '');

const colors = [
  { label: 'No Color', value: '#FFFFFF' },
  { label: 'light Blue', value: '#E2E4EE' },
  { label: 'light Green', value: '#E3EDF0' },
  { label: 'light Orange', value: '#F4E8E8' },
];

const handleCommand = (key: number) => {
  const color = colors[key].value;
  currentColor.value = color;
  $emit('change', color);
  $emit('update:value', color);
  $emit('update:modelValue', color);
};
</script>

<template>
  <el-dropdown :teleported="true" @command="handleCommand" trigger="click" class="w-full">
    <div
      class="flex justify-between items-center bg-white h-[48px] border border-[#a8a8a8] w-full p-[10px] rounded-[10px]"
    >
      <span :style="{ background: currentColor }" class="w-[30px] h-[30px] rounded-[5px]"></span>
      <el-icon size="20">
        <ChevronDown />
      </el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu style="width: 420px">
        <el-dropdown-item :command="key" v-for="(color, key) in colors">
          <div class="w-[100px] pl-[20px] text-left">
            {{ color.label }}
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
